import './inbox_content_view.js.coffee';# Added by Script 
import './social_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.EmailContentView extends Monitoring.Views.SocialContents.InboxContentView

  render: ->
    super
    @$el.addClass("email #{@model.type()}")
    this
